"use client";

import { useTheme } from "next-themes";
import { useMemo } from "react";
import MagicBento, { type MagicBentoCard } from "@/components/magic-bento/MagicBento";
import { getDictionary, type Locale } from "@/lib/i18n";

/** Büyük kartların (idx 2: Yönetim & güvenlik, idx 3: Finans & e-sağlık) hover'da bölündüğü 4 alt öğe */
const SPLIT_ITEMS: Record<number, Record<Locale, string[]>> = {
  2: {
    tr: ["Çok şube & franchise", "Rol, yetki & 2FA", "KVKK uyumu", "AES-256 & yedek"],
    en: ["Multi-branch & franchise", "Roles, 2FA & access", "KVKK compliance", "AES-256 & backups"],
  },
  3: {
    tr: ["Fiyat motoru", "Hakediş & POS", "e-Fatura / e-Reçete", "Raporlama & analiz"],
    en: ["Pricing engine", "Commissions & POS", "e-Invoice / e-Rx", "Reporting & analytics"],
  },
};

/** Ana sayfa: hero bölümünün altında, tam genişlikte responsive bento grid (light: açık zemin, dark: koyu zemin) */
export function HomeMagicBento({ locale }: { locale: Locale }) {
  const { resolvedTheme } = useTheme();
  const glowRgb = useMemo(
    () => (resolvedTheme === "dark" ? "255, 255, 255" : "0, 0, 0"),
    [resolvedTheme],
  );

  const cards: MagicBentoCard[] = useMemo(() => {
    const dict = getDictionary(locale);
    return dict.homeBento.cards.map((c, i) => ({
      label: c.label,
      title: c.title,
      description: c.description,
      subItems: SPLIT_ITEMS[i]?.[locale],
    }));
  }, [locale]);

  return (
    <section className="w-full border-b border-border bg-background px-6 py-5 sm:py-8 md:py-10">
      <div className="mx-auto flex w-full max-w-7xl justify-center">
        <div className="w-full -translate-x-2 sm:-translate-x-4 md:-translate-x-6">
          <MagicBento
            cards={cards}
            textAutoHide
            enableStars={false}
            enableSpotlight={false}
            enableBorderGlow
            enableTilt
            enableMagnetism
            clickEffect
            spotlightRadius={800}
            particleCount={12}
            glowColor={glowRgb}
            disableAnimations={false}
          />
        </div>
      </div>
    </section>
  );
}
